
import { ApiControllers } from "./config";
import { walletsApi, ipRegistry, walletsgridClient, ipStackClient, apiClient,web3Client } from './clients'
import CryptoJS from "crypto-js";
import { arcanaAuth } from "../auth/web3Config";


const getMember = () => {
    return walletsApi.get(ApiControllers.registration + `App/Wallets`);
};
const getIpRegistery = () => {
    return ipRegistry.get("/?key=q329a11cly03mmf2");
};

const twofactor = (custId) => {
    return walletsApi.get(ApiControllers.customers + `twofactor/${custId}`);
};

const isErrorDispaly = (objValue) => {
    if ((objValue.status >= 400 && objValue.status < 500) && objValue.status != 401) {
        return "Something went wrong please try again!";
    } else {
        if (objValue.data && typeof objValue.data === "string") {
            return objValue.data;
        } else if (objValue.data && objValue.data.title && typeof objValue.data.title) {
            return objValue.data.title;
        } else if (
            objValue.originalError &&
            typeof objValue.originalError.message === "string"
        ) {
            return objValue.originalError.message;
        } else {
            return "Something went wrong please try again!";
        }
    }
};
const getOrderHistoryGrid = (apiMethod, id, pageNo, pageSize) => {
    return walletsApi.get(`${apiMethod}/${id}?page=${pageNo}&pageSize=${pageSize}`)
}
const searchTransactions = (type) => {
    return walletsgridClient.get(ApiControllers.transaction + `Customers/${type}`)
}

const encryptValue = (msg, key) => {
    msg = typeof msg == "string" ? msg : JSON.stringify(msg);
    let salt = CryptoJS.lib.WordArray.random(128 / 8);

    let key1 = CryptoJS.PBKDF2(key, salt, {
        keySize: 256 / 32,
        iterations: 10,
    });

    let iv = CryptoJS.lib.WordArray.random(128 / 8);

    let encrypted = CryptoJS.AES.encrypt(msg, key1, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
    });
    return salt.toString() + iv.toString() + encrypted.toString();
};
const getIpStock = () => {
    return ipStackClient.get('check?access_key=f16009057980d892d3b078963e5c51af')
}
const sumsubacesstoken = (userid, flow) => {
    return apiClient.get(
        "Kyc/AccessToken1?applicantId=" + userid + "&levelName=" + flow
    );
};
const handleWeb3User = ({ address, loginToken }) => {
    if (loginToken) {
        return web3Client.get(ApiControllers.customers + "customerCreation/" + address, {}, {
            headers: {
                authorization: loginToken
            }
        })
    }
}

const getArcanaChains = () => {
    return fetch(`${arcanaAuth?.networkConfig?.gatewayUrl}/api/v1/chains/${process.env.REACT_APP_ARCANA_ID}`)
}
let apicalls = {
    getMember,
    handleWeb3User,
    getArcanaChains,
    getIpRegistery,
    twofactor,
    isErrorDispaly, getOrderHistoryGrid, searchTransactions, encryptValue, getIpStock, sumsubacesstoken
};
export default apicalls;
